module.exports = __webpack_public_path__ + "assets/ase.1c300f2e.svg";